module.exports = __webpack_public_path__ + "img/PL09194.c381ca90.png";